import { InputTextarea } from "primereact/inputtextarea";
import { getFormErrorMessage, isFormFieldValid } from "../../utils/formHelper"
import { classNames } from "primereact/utils"
import { FormikValues } from "formik";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    label: string;
    rows?: number;
    value: string;
}

export const FormInputTextarea = (props: Props) => {
    const { disabled, formik, label, rows = 3, value } = props;

    return (
        <div className="field">
            <span className="p-float-label">
                <InputTextarea id={value} name={value} rows={rows} value={formik.values[value]} onChange={formik.handleChange} 
                    disabled={disabled} className={classNames("w-full", { 'p-invalid': isFormFieldValid(value, formik) })} />
                <label htmlFor={value} className={classNames({ 'p-error': isFormFieldValid(value, formik) })}>{label}</label>
            </span>
            {getFormErrorMessage(value, formik)}
        </div>
    )
}